import React from 'react';

import { AnalyticMetric, ProfileKPI } from 'views/analytics/components/ProfileKPI/ProfileKPI';
import { rangeOverAvg, storiesMetricMap, STORIES_ANALYTICS_KPI__CONFIG } from 'views/analytics/utils/kpiConfigs';
import { KPIMetricInput } from 'views/common/components/KPIWidget/KPIWidget';
import SDSRow from 'views/common/components/SDSRow/SDSRow';

import style from './StoriesKPIs.scss';

import { StoriesAnalytics, StoriesMetric } from 'types/analytics';

type Props = {
  activeMetric: AnalyticMetric | null;
  setActiveMetric: (metric: AnalyticMetric) => void;
  storiesAnalyticsSummary?: StoriesAnalytics;
  reportRange: number;
  isLoading: boolean;
};

export function StoriesKPIs(props: Props) {
  const { activeMetric, setActiveMetric, reportRange, storiesAnalyticsSummary, isLoading } = props;

  const getFormattedStoriesKPI = (storiesKPI: KPIMetricInput<StoriesMetric>) => {
    return {
      ...storiesKPI,
      previousValueDescription: rangeOverAvg(reportRange),
    };
  };

  const renderStoriesKPIs = () => {
    const storiesKPIs = STORIES_ANALYTICS_KPI__CONFIG.map(storiesKPI => {
      const formattedProfileKPI = getFormattedStoriesKPI(storiesKPI);
      const metric = storiesMetricMap[formattedProfileKPI.metricId!];

      // @ts-ignore
      const currentValue: number = storiesAnalyticsSummary?.[metric.currentMetrics];

      // @ts-ignore
      const previousValue: number = storiesAnalyticsSummary?.[metric.previousMetrics];
      return (
        <ProfileKPI
          key={formattedProfileKPI.metricId}
          metric={formattedProfileKPI}
          tabSize={storiesKPI.tabSize}
          value={currentValue}
          previousValue={previousValue}
          isActive={activeMetric === formattedProfileKPI.metricId}
          onMetricClicked={setActiveMetric}
          isLoading={isLoading}
        />
      );
    });
    return <SDSRow>{storiesKPIs}</SDSRow>;
  };

  return <div className={style.content}>{renderStoriesKPIs()}</div>;
}
